<template>
  <div
    class="c-avatar position-relative"
    :class="[`c-avatar--${role}`, {'c-avatar--subscriber' : role == 'subscriber'}]">
    <div
      v-if="role == 'team' || role == 'education' || role == 'core' || role == 'agent'"
      class="c-avatar__badge rounded bg-warnings white position-absolute
        d-flex justify-content-center align-items-center"
    >
      <i class="d-flex align-items-center iconf-user fs-14"></i>
    </div>
    <div
      v-else-if="role == 'teacher' || role == 'teacher-pro'"
      class="c-avatar__badge rounded bg-warnings white position-absolute
        d-flex justify-content-center align-items-center">
      <i class="d-flex align-items-center iconf-graduation-cap fs-14"></i>
    </div>
    <div
      v-else-if="role == 'administrator'" class="c-avatar__badge rounded bg-warnings white
        position-absolute d-flex justify-content-center align-items-center">
      <i class="d-flex align-items-center iconf-config fs-14"></i>
    </div>
    <div
      v-else-if="role == 'subscriber'"  class="c-avatar__badge rounded bg-warnings white
        position-absolute d-flex justify-content-center align-items-center">
      <i class="d-flex align-items-center iconf-king fs-14"></i>
    </div>
    <figure class="c-avatar__image rounded overflow-hidden">
      <img :src="photo" class="avatar avatar-thumbnail w-100 h-100 of--cover" :alt="name"/>
    </figure>
  </div>
</template>

<script>
export default {
  props: ['role', 'name', 'photo'],
};
</script>
